/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stat_Countries_ValueInputs */

const en_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const de_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const fr_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const es_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const it_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const nl_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const pl_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const fi_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const da_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

const sv_landing_stat_countries_value = /** @type {(inputs: Landing_Stat_Countries_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10`)
};

/**
* | output |
* | --- |
* | "10" |
*
* @param {Landing_Stat_Countries_ValueInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stat_countries_value = /** @type {((inputs?: Landing_Stat_Countries_ValueInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stat_Countries_ValueInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stat_countries_value(inputs)
	if (locale === "fr") return fr_landing_stat_countries_value(inputs)
	if (locale === "es") return es_landing_stat_countries_value(inputs)
	if (locale === "it") return it_landing_stat_countries_value(inputs)
	if (locale === "nl") return nl_landing_stat_countries_value(inputs)
	if (locale === "pl") return pl_landing_stat_countries_value(inputs)
	if (locale === "fi") return fi_landing_stat_countries_value(inputs)
	if (locale === "da") return da_landing_stat_countries_value(inputs)
	if (locale === "sv") return sv_landing_stat_countries_value(inputs)
	return en_landing_stat_countries_value(inputs)
});